import axios from 'axios'

const CatégorieService = {}

CatégorieService.ajouter =(data,authorization)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/categorie/ajouter`,data,{
    headers:{
    'Authorization': `Bearer ${authorization}` 
    }
})

}

export default CatégorieService